import { MapPoint } from '@/objects/generated';

export type MapMarkerType = 'circle' | 'square' | 'triangle' | 'pin';

export class MapMarker {
    public Key: number | null;

    public Point: MapPoint | null;

    public Title: string;

    public Color: string;

    public Height: number;

    public Width: number;

    public Type: MapMarkerType;

    public ZIndex: number;

    public StrokeColor: string;

    public Visible: boolean;

    public FontFactor: number;

    public onClick?: () => void;

    public constructor() {
        this.Key = null;
        this.Point = null;
        this.Title = '';
        this.Color = '';
        this.Height = 20;
        this.Width = 20;
        this.Type = 'circle';
        this.ZIndex = 1000;
        this.StrokeColor = '#000000bb';
        this.FontFactor = 1;
        this.Visible = true;
    }
}
